"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureType = void 0;
var FeatureType;
(function (FeatureType) {
    FeatureType["SLEEPING_ARRANGEMENT"] = "sleepingArrangement";
    FeatureType["AREA_TO_ENJOY"] = "areaToEnjoy";
    FeatureType["WEDDING_RELATED"] = "weddingRelated";
})(FeatureType = exports.FeatureType || (exports.FeatureType = {}));
//# sourceMappingURL=features.js.map